import axios from 'axios'
import jwtDecode from 'jwt-decode'
import md5 from 'md5'
import { Encrypt  } from './Encrypt'

const cache = {
    '/api/incoterms/kv': null,
    '/api/currencies/kv': null,
    '/api/currencies/all': null,
    '/api/ports/kv': null,
    '/api/warehouses/kv': null,
    '/api/warehouses/sjl-kv': null,
    '/api/divisions/kv': null,
    '/api/warehouse-groups/kv': null,
    '/api/companies/kv': null,
    '/api/employees/kv': null,
    '/api/companies/kvt': null,
    '/api/patterns/works': null,
    '/api/patterns/transport-model': null,
    '/api/charge-items/kv': null,
    '/api/record-units/kv': null,
    '/api/stack-types/kv': null,
    '/api/container-types/kv': null,
    '/api/consumption-tax-rates/kv': null,
    '/api/consumption-tax-rates/all': null,
    '/api/charge-items?size=1000&sort=seq,asc': null,
    '/api/transport-modes/kv': null,
    '/api/companies/forwarders/kv': null,
    '/api/companies/kv?type=PARTNER': null,
    '/api/companies/customs/kv': null,
    '/api/commodity-types/kv': null,
    '/api/countries/kv': null
}

export default {
    install(Vue, {
        store,
        router
    }) {
        const api = axios.create({
            baseURL: '/api',
            timeout: 500000,

            adapter(cfg) {
                if (cfg.clearCache) {
                    cache[cfg.url] = null
                }
                if (cache[cfg.url]) {
                    return cache[cfg.url]
                }
                if (!cfg.quiet) Vue.prototype.$bus.$emit('startLoading', cfg)
                let res = axios.defaults.adapter(cfg).then(response => {
                    let result = Promise.resolve(response)

                    if (!response.config.quiet) Vue.prototype.$bus.$emit('endLoading', cfg)
                    return result
                }).catch(reason => {
                    if (!reason.config.quiet) Vue.prototype.$bus.$emit('endLoading', cfg)
                    return Promise.reject(reason)
                })
                if (cache[cfg.url] === null) {
                    cache[cfg.url] = res
                }
                return res
            }
        })
        let isRefreshing = false;
        let refreshSubscribers = [];

        function subscribeTokenRefresh(cb) {
            refreshSubscribers.push(cb);
        }

        function onRrefreshed(token) {
            refreshSubscribers.map(cb => cb(token));
        }

        function refreshToken() {
            isRefreshing = true
            let refresh_token = localStorage.getItem('refresh_token')
            localStorage.removeItem('access_token')
            localStorage.removeItem('refresh_token')
            var params = new URLSearchParams()
            params.append('grant_type', 'refresh_token')
            params.append('refresh_token', refresh_token)
            return api.post('/login', params, {
                    headers: {
                        Authorization: 'Basic Y2xpZW50OjYyNjA4ZTA4YWRjMjlhOGQ2ZGJjOTc1NGU2NTlmMTI1' //client:62608e08adc29a8d6dbc9754e659f125
                    },
                    inRefreshToken: true
                }).then(res => loadUserDetail(api, res.data))
                .then((user) => {
                    isRefreshing = false
                    onRrefreshed(user.access_token)
                })
        }
        
        //可以拿到所有的Roles
        function loadUserDetail(user){
          localStorage.setItem('access_token',user.access_token)
          localStorage.setItem('user', JSON.stringify(user))
          return Promise.all(
            [
                loadUserProfile(user),
                loadUserFunctions(user)
            ]
        ).then(([roles,functions])=>{
          user.roles = roles
          user.functions = functions
          return user
        })
          //user.access_token,user.identityInfoList[0].identityId
        }
        function loadUserProfile(user){
          return api.get(`/auth-service/auth/get-user-info?userId=${user.identityInfoList[0].identityId}`,{
            headers: {
              token:user.access_token
            }
          }).then(res=>{
            console.log(res.data)
            if(res.data.success){
              return res.data.data.roles
            }
            return []
          }).catch(()=>{
            return []
          })
        }
        function loadUserFunctions(user){
          return api.get(`/auth-service/auth/get-user-functions`,{
            headers: {
              token: user.access_token
            }
          }).then(res=>{
            if(res.data.success){
              return res.data.data
            }
            return []
          }).catch(()=>{
            return []
          })
        }

        function loginAs(user){
          return api.post(`/auth-service/auth/login-as?userId=${user.identityInfoList[0].identityId}`,{},{
            headers: {
              token: user.access_token
            }
          }).then(res=>{
            console.log(res)
            if(res.data.success){
              return loadUserDetail(user)
            }else{
              return Promise.reject(res)
            }
          })
        }

        function login(username, password) {
            localStorage.removeItem('access_token')
            return api.post(`/auth-service/auth/login`,{
              username:username,
              password:Encrypt(password)
            }).then(res=>{
              if(!res.data.access_token){
                return Promise.reject(res)
              }
              if(res.data.identityInfoList.length === 0){
                res.data.errorCode = 'NO_IDENTITY_LIST'
                return Promise.reject(res)
              }
              if(!!res.data.access_token){
                return loginAs(res.data)
              }
            }).catch(err=>{
              return Promise.reject(err)
            })
        }

        function getFilenameFromContentDispositionHeader(contentDisposition) {
            // This parser is designed to be tolerant and accepting of headers that do
            // not comply with the standard, but accepted by Firefox.

            let needsEncodingFixup = true;

            // filename*=ext-value ("ext-value" from RFC 5987, referenced by RFC 6266).
            let tmp = toParamRegExp('filename\\*', 'i').exec(contentDisposition);
            if (tmp) {
                tmp = tmp[1];
                let filename = rfc2616unquote(tmp);
                filename = unescape(filename);
                filename = rfc5987decode(filename);
                filename = rfc2047decode(filename);
                return fixupEncoding(filename);
            }

            // Continuations (RFC 2231 section 3, referenced by RFC 5987 section 3.1).
            // filename*n*=part
            // filename*n=part
            tmp = rfc2231getparam(contentDisposition);
            if (tmp) {
                // RFC 2047, section 
                let filename = rfc2047decode(tmp);
                return fixupEncoding(filename);
            }

            // filename=value (RFC 5987, section 4.1).
            tmp = toParamRegExp('filename', 'i').exec(contentDisposition);
            if (tmp) {
                tmp = tmp[1];
                let filename = rfc2616unquote(tmp);
                filename = rfc2047decode(filename);
                return fixupEncoding(filename);
            }
            return '';

            function toParamRegExp(attributePattern, flags) {
                return new RegExp(
                    '(?:^|;)\\s*' + attributePattern + '\\s*=\\s*' +
                    // Captures: value = token | quoted-string
                    // (RFC 2616, section 3.6 and referenced by RFC 6266 4.1)
                    '(' +
                    '[^";\\s][^;\\s]*' +
                    '|' +
                    '"(?:[^"\\\\]|\\\\"?)+"?' +
                    ')', flags);
            }

            function textdecode(encoding, value) {
                if (encoding) {
                    try {
                        let decoder = new TextDecoder(encoding, {
                            fatal: true
                        });
                        let bytes = Array.from(value, c => c.charCodeAt(0));
                        if (bytes.every(code => code <= 0xFF)) {
                            value = decoder.decode(new Uint8Array(bytes));
                            needsEncodingFixup = false;
                        }
                    } catch (e) {
                        // TextDecoder constructor threw - unrecognized encoding.
                    }
                }
                return value;
            }

            function fixupEncoding(value) {
                if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                    // Maybe multi-byte UTF-8.
                    value = textdecode('utf-8', value);
                    if (needsEncodingFixup) {
                        // Try iso-8859-1 encoding.
                        value = textdecode('iso-8859-1', value);
                    }
                }
                return value;
            }

            function rfc2231getparam(contentDisposition) {
                let matches = [],
                    match;
                // Iterate over all filename*n= and filename*n*= with n being an integer
                // of at least zero. Any non-zero number must not start with '0'.
                let iter = toParamRegExp('filename\\*((?!0\\d)\\d+)(\\*?)', 'ig');
                while ((match = iter.exec(contentDisposition)) !== null) {
                    let [, n, quot, part] = match;
                    n = parseInt(n, 10);
                    if (n in matches) {
                        // Ignore anything after the invalid second filename*0.
                        if (n === 0) break;
                        continue;
                    }
                    matches[n] = [quot, part];
                }
                let parts = [];
                for (let n = 0; n < matches.length; ++n) {
                    if (!(n in matches)) {
                        // Numbers must be consecutive. Truncate when there is a hole.
                        break;
                    }
                    let [quot, part] = matches[n];
                    part = rfc2616unquote(part);
                    if (quot) {
                        part = unescape(part);
                        if (n === 0) {
                            part = rfc5987decode(part);
                        }
                    }
                    parts.push(part);
                }
                return parts.join('');
            }

            function rfc2616unquote(value) {
                if (value.startsWith('"')) {
                    let parts = value.slice(1).split('\\"');
                    // Find the first unescaped " and terminate there.
                    for (let i = 0; i < parts.length; ++i) {
                        let quotindex = parts[i].indexOf('"');
                        if (quotindex !== -1) {
                            parts[i] = parts[i].slice(0, quotindex);
                            parts.length = i + 1; // Truncates and stop the iteration.
                        }
                        parts[i] = parts[i].replace(/\\(.)/g, '$1');
                    }
                    value = parts.join('"');
                }
                return value;
            }

            function rfc5987decode(extvalue) {
                // Decodes "ext-value" from RFC 5987.
                let encodingend = extvalue.indexOf('\'');
                if (encodingend === -1) {
                    // Some servers send "filename*=" without encoding'language' prefix,
                    // e.g. in https://github.com/Rob--W/open-in-browser/issues/26
                    // Let's accept the value like Firefox (57) (Chrome 62 rejects it).
                    return extvalue;
                }
                let encoding = extvalue.slice(0, encodingend);
                let langvalue = extvalue.slice(encodingend + 1);
                // Ignore language (RFC 5987 section 3.2.1, and RFC 6266 section 4.1 ).
                let value = langvalue.replace(/^[^']*'/, '');
                return textdecode(encoding, value);
            }

            function rfc2047decode(value) {
                // RFC 2047-decode the result. Firefox tried to drop support for it, but
                // backed out because some servers use it - https://bugzil.la/875615
                // Firefox's condition for decoding is here: https://searchfox.org/mozilla-central/rev/4a590a5a15e35d88a3b23dd6ac3c471cf85b04a8/netwerk/mime/nsMIMEHeaderParamImpl.cpp#742-748

                // We are more strict and only recognize RFC 2047-encoding if the value
                // starts with "=?", since then it is likely that the full value is
                // RFC 2047-encoded.

                // Firefox also decodes words even where RFC 2047 section 5 states:
                // "An 'encoded-word' MUST NOT appear within a 'quoted-string'."

                // eslint-disable-next-line no-control-regex
                if (!value.startsWith('=?') || /[\x00-\x19\x80-\xff]/.test(value)) {
                    return value;
                }
                // RFC 2047, section 2.4
                // encoded-word = "=?" charset "?" encoding "?" encoded-text "?="
                // charset = token (but let's restrict to characters that denote a
                //           possibly valid encoding).
                // encoding = q or b
                // encoded-text = any printable ASCII character other than ? or space.
                //                ... but Firefox permits ? and space.
                return value.replace(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g,
                    function (_, charset, encoding, text) {
                        if (encoding === 'q' || encoding === 'Q') {
                            // RFC 2047 section 4.2.
                            text = text.replace(/_/g, ' ');
                            text = text.replace(/=([0-9a-fA-F]{2})/g,
                                (_, hex) => String.fromCharCode(parseInt(hex, 16)));
                            return textdecode(charset, text);
                        } // else encoding is b or B - base64 (RFC 2047 section 4.1)
                        try {
                            text = atob(text);
                        } catch (e) {}
                        return textdecode(charset, text);
                    });
            }
        }

        function fileDownload(url, fileName) {
            axios({
                method: 'get',
                url: url,
                responseType: 'blob',
            }).then(res => {
                this.$downloadFile(res, fileName)
            })
        }

        function download(url, params) {
            console.log(url)
            console.log(params)
            return api.get(url, {
                    params: params,
                    responseType: 'blob'
                })
                .then(res => {
                    console.log(res)
                    console.log('改造成parseResponseExcel');
                    parseResponseExcel(res);
                })
        }

        function postDownload(url, params) {
            console.log(url)
            console.log(params)
            return api.post(url, {
                    ...(params || {}),
                    responseType: 'blob'
                })
                .then(res => {
                    parseResponseExcel(res)
                })
        }

        function parseResponseExcel(res) {
            const blob = new Blob([res.data], {
                type: 'application/vnd.ms-excel'
            })

            const fileName = getFilenameFromContentDispositionHeader(res.headers['content-disposition']);

            if ('download' in document.createElement('a')) {
                // 非IE下载
                const elink = document.createElement('a')
                elink.download = decodeURI(fileName)
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
            } else {
                // IE10+下载
                navigator.msSaveBlob(blob, decodeURI(fileName))
            }
        }

        api.interceptors.request.use(
            cfg => {
                var access_token = localStorage.getItem('access_token')
                if (access_token) {
                  cfg.headers.Authorization = `Bearer ${access_token}`
                  cfg.headers.token = access_token
              }
              return cfg
            },
            err => {
                return Promise.reject(err)
            }
        )

        api.interceptors.response.use(
            res => {
              if(res.data.success === false && (res.data.errorCode === '40012' || res.data.errorCode === '403' || res.data.errorCode === '401')){
                    Vue.prototype.$message("Error","システムに登録された情報が失効したため、もう一度登録してください。");
                    localStorage.removeItem('access_token')
                    localStorage.removeItem('refresh_token')
                    localStorage.removeItem('user')
                    store.dispatch('LOGOUT')
                    router.push('B0100')
              }
                return Promise.resolve(res)
            },
            err => {
              console.log(err.response)
              if(err.response && 'AUTH_FAILED' === err.response.data.message){
                  Vue.prototype.$message("Error","システムに登録された情報が失効したため、もう一度登録してください。");
                  //alert('token失效')
                  localStorage.removeItem('access_token')
                  localStorage.removeItem('refresh_token')
                  localStorage.removeItem('user')
                  store.dispatch('LOGOUT')
                  router.push('B0100')
              }
                if (!err.response) {
                    return Promise.reject("TimeOut")
                }
                const {
                    config,
                    response: {
                        status
                    }
                } = err


                if (config.inRefreshToken) {
                    localStorage.removeItem('access_token')
                    localStorage.removeItem('refresh_token')
                    localStorage.removeItem('user')
                    store.dispatch('LOGOUT')
                    router.push('B0100')
                } else if (status === 401 && !config.inLogin) {
                    if (!isRefreshing) {
                        refreshToken()
                    }
                    return new Promise(resolve => {
                        subscribeTokenRefresh(token => {
                            config.headers['Authorization'] = 'Bearer ' + token
                            resolve(api({
                                ...config,
                                baseURL: null
                            }))
                        })
                    })
                }
                return Promise.reject(err)
            }
        )

        function permit(funcs) {
            let user = store.getters.user
            // return true
            return user 
            && user.functions 
            && user.functions
            .filter(f => f != null)
            .find(f => funcs.indexOf(f.code) !== -1)
        }
        Vue.prototype.$http = api
        Vue.prototype.$login = login
        Vue.prototype.$permit = permit
        Vue.prototype.$download = download
        Vue.prototype.$fileDownload = fileDownload
        Vue.prototype.$postDownload = postDownload
        Vue.prototype.$parseResponseExcel = parseResponseExcel

        //sample: v-permit.SHARP_PO_INV_CSV_DOWNLOAD
        Vue.directive('permit', {
            inserted(el, binding, vnode) {
                //vnode.elm.style.display = 'none'
                //console.log(vnode.elm)
                if (!permit(Object.keys(binding.modifiers))) {
                    vnode.elm.parentElement.removeChild(vnode.elm)
                }
            },
        })

        //sample: v-permit=['SHARP_PO_INV_CSV_DOWNLOAD','abc']
        Vue.directive('permit-all', {
            inserted(el, binding, vnode) {
                //vnode.elm.style.display = 'none'
                //console.log(vnode.elm)
                if (!permit(binding.value)) {
                    vnode.elm.parentElement.removeChild(vnode.elm)
                }
            },
        })
    }
}